import { render, staticRenderFns } from "./BusinessEditTabPlaces.vue?vue&type=template&id=c701d302&"
import script from "./BusinessEditTabPlaces.vue?vue&type=script&lang=js&"
export * from "./BusinessEditTabPlaces.vue?vue&type=script&lang=js&"
import style0 from "./BusinessEditTabPlaces.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports